import request from '@/assets/js/myAxios'

export async function GetCollectList(data) {
  return request({
    url: '/api/mall_collect/GetCollectList?id='+data,
    method: 'get',
  })
}


export async function AddCollect(id,data) {
  return request({
    url: '/api/mall_collect/AddCollect?id='+id,
    method: 'post',
    data
  })
}


export async function DeleteCollect(id,data) {
  return request({
    url: '/api/mall_collect/DeleteCollect?id='+id,
    method: 'post',
    data
  })
}